import { render, staticRenderFns } from "./VarietiesList.vue?vue&type=template&id=f0e23108&scoped=true&"
import script from "./VarietiesList.vue?vue&type=script&lang=js&"
export * from "./VarietiesList.vue?vue&type=script&lang=js&"
import style0 from "./VarietiesList.vue?vue&type=style&index=0&id=f0e23108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e23108",
  null
  
)

export default component.exports